import { useState } from "react";
import { useSession, ModeNote, Panel, Label, Felt } from "./usePlay";
import { Hand } from "./PlayingCard";
import { BetControl } from "@/components/game/BetControl";
import { fmtAZN } from "@/lib/api";
import { sfx } from "@/lib/sound";

const RESULT = { win: ["Qazandınız!", "text-emerald-300"], blackjack: ["BLACKJACK! 3:2", "text-[#FFD700]"], push: ["Heç-heçə · mərc qaytarıldı", "text-sky-300"], lose: ["Diler qazandı", "text-red-300"] };

export const BlackjackGame = ({ mode }) => {
  const { g, busy, call, active } = useSession("/games/blackjack", () => sfx.flip());
  const [bet, setBet] = useState(1);
  const act = (a) => call(a, { game_id: g.game_id });
  const res = g && !active && RESULT[g.result];
  return (
    <div className="grid lg:grid-cols-[340px_1fr] gap-6" data-testid="blackjack-game">
      <Panel className="order-2 lg:order-1">
        <div><Label>Mərc</Label><BetControl value={bet} onChange={setBet} disabled={active || busy} testid="bj-bet" /></div>
        <ModeNote g={g} mode={mode} />
        {active ? (
          <div className="grid grid-cols-3 gap-2">
            <button disabled={busy} onClick={() => act("hit")} className="rounded-xl py-3 bg-emerald-600 hover:bg-emerald-500 font-display font-bold transition-colors" data-testid="bj-hit-btn">Kart</button>
            <button disabled={busy} onClick={() => act("stand")} className="rounded-xl py-3 bg-red-600 hover:bg-red-500 font-display font-bold transition-colors" data-testid="bj-stand-btn">Dayan</button>
            <button disabled={busy || !g.can_double} onClick={() => act("double")} className="rounded-xl py-3 bg-[#D4AF37] text-black hover:brightness-110 font-display font-bold disabled:opacity-40" data-testid="bj-double-btn">x2</button>
          </div>
        ) : (
          <button disabled={busy} onClick={() => call("start", { bet, mode })} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="bj-deal-btn">Payla</button>
        )}
        <ul className="text-xs text-zinc-500 space-y-1">
          <li>Blackjack 3:2 ödəyir, qələbə 1:1.</li>
          <li>Diler 17-də dayanır. İkiqat yalnız ilk 2 kartda.</li>
        </ul>
      </Panel>
      <Felt className="flex flex-col items-center justify-between gap-6" testid="bj-table">
        {g ? (
          <>
            <Hand cards={g.dealer} label="Diler" total={g.dealer_total} hidden={active ? 1 : 0} testid="bj-dealer" />
            <div className="h-10 flex items-center">
              {res && <p className={`font-display font-black text-2xl sm:text-3xl ${res[1]}`} data-testid="bj-result">{res[0]}{g.win > 0 && g.result !== "push" ? ` +${fmtAZN(g.win)}` : ""}</p>}
              {active && <p className="text-white/60 text-sm">Mərc: {fmtAZN(g.bet)}</p>}
            </div>
            <Hand cards={g.player} label="Siz" total={g.player_total} testid="bj-player" />
          </>
        ) : (
          <div className="m-auto text-center space-y-3"><p className="font-display font-black text-5xl gold-text">BLACKJACK</p><p className="text-white/60 text-sm">Mərci seçin və "Payla" düyməsini basın</p></div>
        )}
      </Felt>
    </div>
  );
};
